import { managerAuthModule } from '@agos/manager-auth'
import { managerCustomersModule } from '@agos/manager-customers'
import { managerDashboardModule } from '@agos/manager-dashboard'
import { managerDeliveryModule } from '@agos/manager-delivery'
import { managerDrivingModule } from '@agos/manager-driving'
import { managerPlatformModule } from '@agos/manager-platform'
import { managerHrModule } from '@agos/manager-hr'
import { managerInventoryModule } from '@agos/manager-inventory'
import { managerInvoicingModule } from '@agos/manager-invoicing'
import { managerMarketingSiteModule } from '@agos/manager-marketing-site'
import { managerKasaModule } from '@agos/manager-kasa'
import { managerMenuModule } from '@agos/manager-menu'
import { managerOrdersModule } from '@agos/manager-orders'
import { managerReportingModule } from '@agos/manager-reporting'
import { managerSettingsModule } from '@agos/manager-settings'

import type { ManagerModule, ModuleRoute } from './module-contract'

/**
 * Every feature module the shell composes.
 *
 * Adding one here must move its pages from unported to ported in
 * `FRONTEND-STATUS.md` in the same commit, and `route-diff.test.ts` fails the
 * build while the composed table and `docs/INVENTORY/manager-routes.json`
 * disagree.
 */
export const managerModules: ManagerModule[] = [
  managerAuthModule as unknown as ManagerModule,
  managerDashboardModule as unknown as ManagerModule,
  managerMenuModule as unknown as ManagerModule,
  managerOrdersModule as unknown as ManagerModule,
  managerDeliveryModule as unknown as ManagerModule,
  managerDrivingModule as unknown as ManagerModule,
  managerPlatformModule as unknown as ManagerModule,
  managerKasaModule as unknown as ManagerModule,
  managerInventoryModule as unknown as ManagerModule,
  managerInvoicingModule as unknown as ManagerModule,
  managerCustomersModule as unknown as ManagerModule,
  managerHrModule as unknown as ManagerModule,
  managerReportingModule as unknown as ManagerModule,
  managerMarketingSiteModule as unknown as ManagerModule,
  managerSettingsModule as unknown as ManagerModule,
]

export function composedRoutes(): ModuleRoute[] {
  return managerModules.flatMap((module) => module.routes)
}

/** The catch-all is mounted last, after every real path has had its chance. */
export function catchAllRoute(): ModuleRoute | undefined {
  return composedRoutes().find((route) => route.path === '*')
}

export function pathRoutes(): ModuleRoute[] {
  return composedRoutes().filter((route) => route.path !== '*')
}
